/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".mydp[_ngcontent-%COMP%]   .mydpicon[_ngcontent-%COMP%]{border:1px solid rgba(0,0,0,.125)!important;padding:4px!important}"];
export { styles as styles };

